interface LogoProps {
  /** 'light' = white wordmark (dark backgrounds); 'dark' = charcoal wordmark. */
  tone?: 'light' | 'dark';
  /** Rendered height in px; width scales with the 5.27:1 lockup ratio. */
  height?: number;
  className?: string;
}

/**
 * Flying Muse horizontal lockup - the Winged Victory emblem + wordmark + tagline.
 */
export function Logo({ tone = 'light', height = 40, className = '' }: LogoProps) {
  const src = tone === 'light' ? '/img/logo-horizontal.webp' : '/img/logo-horizontal-dark.webp';
  // The lockup is 1054x200 (5.27:1); derive width from the rendered height.
  const width = Math.round((height * 1054) / 200);
  return (
    <img
      src={src}
      alt="Flying Muse - Santorini Photography"
      width={width}
      height={height}
      style={{ height, width: 'auto' }}
      className={`block w-auto ${className}`}
    />
  );
}
